import { render } from "./TagStatus.vue?vue&type=template&id=3ee6038d&scoped=true"
import script from "./TagStatus.vue?vue&type=script&lang=js"
export * from "./TagStatus.vue?vue&type=script&lang=js"

import "./TagStatus.vue?vue&type=style&index=0&id=3ee6038d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee6038d"]])

export default __exports__